import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import Header from "../components/Header";
import Footer from "../components/Footer";
import Markdown from '../components/Markdown';
import { BlogCategory } from "./Blog";

import { blogs, blogCategories } from '../constants/blog';

import './Home.css';
import './BlogPost.css';

const BlogPost = () => {

    const navigate = useNavigate();
    const { blogTitle } = useParams();

    let bodyText = [];
    let customMarkdown = [];
    let title = "";
    let image = "";
    let seoDescription = "";
    let seoKeywords = "";
    let video = null;

    let nextBlog = null;
    let category = "";

    // Get the blog object from the blogId
    let blog = undefined;
    for (let i = 0; i < blogs.length; i++) {
        if (blogs[i].formattedTitle == blogTitle) {
            blog = blogs[i];
            // If this isn't the last blog, set the next blog
            if (i < blogs.length - 1) {
                //setNextBlog(blogs[i + 1]);
                nextBlog = blogs[i + 1];
            }
        }
    }

    if (blog !== undefined) {

        const keywords = blog.keywords;
        seoKeywords = keywords.join(", ");

        const description = blog.description;
        seoDescription = description;

        let allTextBlocks = blog.bodyText;
        // Break the text on {break}
        allTextBlocks = allTextBlocks.split("{break}");

        // Check for any custom markdown
        const allCustomMarkdown = blog.customMarkdown == undefined ? [] : blog.customMarkdown;
        const customMarkdownImages = blog.customMarkdownImages == undefined ? [] : blog.customMarkdownImages;
        let customMarkdownToRender = [];
        for (let i = 0; i < allCustomMarkdown.length; i++) {
            // Each custom markdown is an array fo 2 objects with the markdown to render
            let customMarkdown = allCustomMarkdown[i];
            let customMarkdownLeft = customMarkdown[0]["text"];
            let customMarkdownRight = customMarkdown[1]["text"];

            for (let i = 0; i < customMarkdownImages.length; i++) {
                const image = customMarkdownImages[i];
                customMarkdownLeft = customMarkdownLeft.replace(`{customImage_${i + 1}}`, `![alt text](${require(`../assets/blogImages/${image}`)})`);
                customMarkdownRight = customMarkdownRight.replace(`{customImage_${i + 1}}`, `![alt text](${require(`../assets/blogImages/${image}`)})`);
            }
            customMarkdownToRender.push([
                { text: customMarkdownLeft, flex: customMarkdown[0]["flex"] },
                { text: customMarkdownRight, flex: customMarkdown[1]["flex"] }
            ]);

        }
        customMarkdown = customMarkdownToRender;

        let textBlocks = [];
        for (let i = 0; i < allTextBlocks.length; i++) {

            let text = allTextBlocks[i];
            text = text.replaceAll("{container}", "<container></container>")

            textBlocks.push(text);

        }

        video = blog.video;
        video = video == undefined ? null : video;

        bodyText = textBlocks;
        title = blog.title;
        image = blog.image;
        category = blog.category;

    }

    useEffect(() => {
        // Make sure the page starts at the top
        window.scrollTo(0, 0);
    }, [blog]);

    return (

        <div className="blog-post-section">

            <Header />

            <Helmet>
                <title>{title}</title>
                <meta name="description" content={seoDescription} />
                <meta name="keywords" content={seoKeywords} />
            </Helmet>

            <div className="blog-post-main-section">

                <div className="blog-page-left-sidebar">
                    <p id="blog-learn-text">Learn</p>
                    {blogCategories.map((blogCategory, index) =>
                        <div key={index}>
                            <BlogCategory
                                category={blogCategory.formattedTitle}
                                blogs={blogs.filter(blog => blog.category == blogCategory.title)}
                                onTitleClick={() => navigate(`/${blogCategory.title}`)}
                                isSelected={category == blogCategory.title}
                                defaultIsOpen={category == blogCategory.title}
                                currentBlogTitle={blogTitle}
                            />
                        </div>
                    )}
                </div>

                <div className="blog-post-container">

                    <div className="blog-post-header-row">
                        <div className="blog-post-header-image-col">
                            <img className="blog-post-image" loading="lazy" src={image == "" ? null : require(`../assets/blogImages/${image}`)} />
                            <p className="blog-title">{title}</p>
                        </div>
                    </div>

                    {video !== null &&
                        <VideoSection
                            url={video["url"]}
                            title={video["title"]}
                        />
                    }

                    <div className="blog-post-main-col">
                        {bodyText.map((text, index) =>
                            <div key={index}>
                                <Markdown
                                    markdownContent={text}
                                    className={"blog-post-text"}
                                />

                                {customMarkdown.length > 0 &&
                                    <div className="blog-custom-markdown-container">
                                        {customMarkdown[index] !== undefined && <div className="blog-custom-markdown-left-col" style={{ display: "flex", flex: customMarkdown[index][0]["flex"] }}>
                                            <Markdown
                                                markdownContent={customMarkdown[index][0]["text"]}
                                                className={"blog-post-text"}
                                                customImageStyle={{ width: "100%" }}
                                            />
                                        </div>}
                                        {customMarkdown[index] !== undefined && <div className="blog-custom-markdown-right-col" style={{ display: "flex", flex: customMarkdown[index][1]["flex"] }}>
                                            <Markdown
                                                markdownContent={customMarkdown[index][1]["text"]}
                                                className={"blog-post-text"}
                                                customImageStyle={{ width: "100%" }}
                                            />
                                        </div>}
                                    </div>
                                }
                            </div>
                        )}

                        {nextBlog !== null &&
                            <div className="next-post-container">
                                <p className="next-post-button" onClick={() => navigate(`/learn/${nextBlog.formattedTitle}`)}>
                                    Next:<b className="next-post-title">{nextBlog.title} {"->"}</b>
                                </p>
                            </div>
                        }

                    </div>

                </div>

            </div>

            <Footer />
        </div>
    )

}


const VideoSection = ({ url, title }) => {

    return (
        <div className="platform-guidance-video" style={{marginTop: "40px"}}>
            <iframe
                src={url}
                title={title}
                frameBorder="0"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen>
            </iframe>
        </div>
    )

}

export default BlogPost;

